const user = {
  labels: {
    surname: "Фамилия",
    name: "Имя",
    patronymic: "Отчество",
    password: "Пароль",
    workplace: "Рабочее место",
    role_id: null,
  },
  maxLength: {
    surname: 75,
    name: 75,
    workplace: 40,
    patronymic: 75,
    password: 32,
    role_id: 1,
  },
};

const passport = {
  labels: {
    date_of_birth: "Дата рождения",
    place_of_birth: "Место рождения",
    registration_address: "Адрес регистрации",
    number: "Номер паспорта",
    series: "Серия паспорта",
    obtaining_passport_place: "Место выдачи паспорта",
    obtaining_passport_date: "Дата выдачи паспорта",
  },
  maxLength: {
    date_of_birth: 20,
    place_of_birth: 70,
    registration_address: 70,
    number: 30,
    series: 30,
    obtaining_passport_place: 70,
    obtaining_passport_date: 20,
  },
  inputTypes: {
    date_of_birth: "date",
    place_of_birty: "text",
    registration_address: "text",
    number: "text",
    series: "text",
    obtaining_passport_place: "text",
    obtaining_passport_date: "date",
  },
};

const shiftsCalendar = {
  labels: {
    name: 'Название',
    description: 'Дополнительное описание',
    dates: 'Даты календаря',
    times: 'Время смен',
    users: 'Пользователи, работающие по календарю',
  },
  maxLength: {
    name: 40,
    description: 40,
  },
};

const achievement = {
  labels: {
    name: 'Название',
    description: 'Короткое описание',
    receipt_condition: 'Условие получения',
    users: "Пользователи",
    icon_background: 'Цвет иконки',
    icon_name: 'Цвет иконки',
  },
  maxLength: {
    name: 38,
    description: 80,
    receipt_condition: 80,
  },
};

export const formsFields = {
  user,
  passport,
  shiftsCalendar,
  achievement,
};



// WEBPACK FOOTER //
// ./src/user/constants/formsFields.js